import { render, staticRenderFns } from "./SalaHeader.vue?vue&type=template&id=eebaed92&"
import script from "./SalaHeader.vue?vue&type=script&lang=js&"
export * from "./SalaHeader.vue?vue&type=script&lang=js&"
import style0 from "./SalaHeader.vue?vue&type=style&index=0&id=eebaed92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports